import { useState } from "react";
import PageLayout, { Section } from "./PageLayout";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // Simulate send
    setSent(true);
    toast.success("Message received — we'll reply within 24 hours.");
    setForm({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <PageLayout
      eyebrow="Contact"
      title="Talk to us."
      subtitle="Whether it's a bug, a partnership, or just to say hi — we read every message."
    >
      <div className="grid lg:grid-cols-[1fr_320px] gap-8">
        <Section>
          <form onSubmit={submit} className="space-y-4 bg-[#0d0d0d] border border-white/5 rounded-2xl p-6 sm:p-8" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Name</label>
                <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" data-testid="contact-name" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Email</label>
                <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" data-testid="contact-email" />
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Subject</label>
              <select required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" data-testid="contact-subject">
                <option value="">Select a topic...</option>
                <option>Account & login</option>
                <option>Billing & subscriptions</option>
                <option>Content suggestion</option>
                <option>Partnership</option>
                <option>Press inquiry</option>
                <option>Bug report</option>
                <option>Other</option>
              </select>
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Message</label>
              <textarea required rows="6" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none resize-none" data-testid="contact-message" />
            </div>
            <button type="submit" className="btn-primary w-full sm:w-auto justify-center" data-testid="contact-submit">
              <Send size={16} /> {sent ? "Sent ✓" : "Send message"}
            </button>
          </form>
        </Section>

        <aside className="space-y-3">
          {[
            { icon: Mail, title: "General inquiries", value: "hello@djinostream.com", href: "mailto:hello@djinostream.com" },
            { icon: Mail, title: "Customer support", value: "support@djinostream.com", href: "mailto:support@djinostream.com" },
            { icon: Mail, title: "Press", value: "press@djinostream.com", href: "mailto:press@djinostream.com" },
            { icon: Phone, title: "Phone (Mon–Fri)", value: "+243 81 000 0000", href: "tel:+243810000000" },
            { icon: MapPin, title: "HQ", value: "Boulevard du 30 Juin, Kinshasa, DRC" },
          ].map((c, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-4 flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center flex-shrink-0">
                <c.icon size={18} />
              </div>
              <div>
                <div className="text-xs text-[#888] uppercase tracking-wider">{c.title}</div>
                {c.href ? <a href={c.href} className="text-sm font-semibold text-white hover:text-[#E50914]">{c.value}</a> : <div className="text-sm font-semibold text-white">{c.value}</div>}
              </div>
            </div>
          ))}
        </aside>
      </div>
    </PageLayout>
  );
}
